import tooltipNavnetryk from '../../../../assets/cls-dk/products/pdp-tooltips/tryk-navn-logo.jpg';
import tooltipSpecialTekst from '../../../../assets/cls-dk/products/pdp-tooltips/example_special-tekst.jpg';
import tooltipFlag from '../../../../assets/cls-dk/products/pdp-tooltips/example_flag_print.jpg';
import tooltipBogstav from '../../../../assets/cls-dk/products/pdp-tooltips/example_klassens_bogstav.jpg';
import tooltipBrysttryk from '../../../../assets/cls-dk/products/pdp-tooltips/example_lille_brysttryk.jpg';
import tooltipRygtryk from '../../../../assets/cls-dk/products/pdp-tooltips/rygtryk_a4.jpg';

export const ADDON_TOOLTIPS = {
  navnetryk: {
    title: 'Exempel namntryck',
    image: tooltipNavnetryk,
    description: 'Här har du möjlighet att få namntryck. Max 16 tecken inklusive mellanslag. Namnet placeras på ena bröstet. Observera att specialtecken som kinesiska m.m. inte är möjliga.\n\n(Kontrollera att ditt namn är korrekt stavat – både här och på den ritning som görs för ryggtryck)',
  },
  specialTekst: {
    title: 'Exempel specialtext',
    image: tooltipSpecialTekst,
    description: 'T.ex. namn på Instagram eller smeknamn. Texten trycks på ärmen. Max 16 tecken inklusive mellanslag.',
  },
  flag: {
    title: 'Exempel flagga',
    image: tooltipFlag,
    description: 'Välj en flagga som trycks på ärmen av din tröja. Flaggan är ca 3×2 cm.',
  },
  klassensBogstav: {
    title: 'Exempel klassbokstav',
    image: tooltipBogstav,
    description: 'Klassbokstaven broderas på ärmen. Välj den bokstav som passar din klass.',
  },
  lilleBrysttryk: {
    title: 'Exempel litet brösttryck',
    image: tooltipBrysttryk,
    description: 'Skolans logotyp eller egen logotyp (tryck) placeras på bröstet. Observera att detta är ett tryck – inte broderi.',
  },
  rygtryk: {
    title: 'Exempel ryggtryck',
    image: tooltipRygtryk,
    description: 'En unik design för din klass som trycks på ryggen av tröjan. Du kan välja mellan A4 och A3 format.',
  },
};
